import { API_USERNAME, API_PASSWORD } from './config.js.dist';
import {
    getInitialProductsFromCollection,
    getPaginatedProductsFromCollection,
    getFilteredProductsFromCollection,
    getFilteredProductsFromCollectionPagination,
    getInitialProductVariants,
    getPaginatedProductVariants,
} from './queries';
import getProductById from './queries/getProductById';

/**
 * API
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @author Matt Haynes <Matthew.haynes@joipolloi.com>
 * @package Minifigs
 */

/* eslint-disable */

class API {
    // constructor() {
    //     this.afterCursor = null;
    // }

    async getConfig() {
        const resp = await fetch('https://minifigs-builder-filter-config.s3.eu-west-2.amazonaws.com/production.json', {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            timeout: 5000,
        });
        const config = await resp.json();
        return config;
    }

    /**
     * Get the top level categories for a section
     * * * * THIS IS NO LONGER IN USE AS WE DON'T GO INTO SUB CATEGORIES THIS WAY ANY LONGER.
     *
     * @param {string} sectionId
     * @return Promise
     */
    getCategories(sectionId) {
        // These products are all pseudo products, named like: A_MINIFIG_BUILDER_sectionId
        // Can be viewed here: https://minifigs.me/admin/products?query=A_MINI

        // If you add a collection handle to the description of this these products
        // then that collection and all of its products will be added to the relevant place

        const productDescriptions = [
            {
                url: '/products/a_minifig_builder_hatsAndHair.js',
                type: 'hatsAndHair',
            },
            {
                url: '/products/a_minifig_builder_heads.js',
                type: 'heads',
            },
            {
                url: '/products/a_minifig_builder_bodies.js',
                type: 'bodies',
            },
            {
                url: '/products/a_minifig_builder_legs.js',
                type: 'legs',
            },
            {
                url: '/products/a_minifig_builder_display.js',
                type: 'display',
            },
            {
                url: '/products/a_minifig_builder_accessories.js',
                type: 'accessory',
            },
        ];

        const getData = () => {
            return Promise.all(
                productDescriptions.map((product) => {
                    return fetch(product.url)
                        .then((response) => response.json())
                        .then((data) => {
                            return Array.from(data.description.split(','));
                        })
                        .then((data) => {
                            if (product.type === 'accessory') {
                                categoryMap.accessory1 = data;
                                categoryMap.accessory2 = data;
                                categoryMap.accessory3 = data;
                            } else {
                                categoryMap[product.type] = data;
                            }
                        })
                        .catch((err) => {
                            console.log('Fetch Error :-S', err);
                        });
                })
            );
        };

        const categoryMap = {
            hatsAndHair: [],
            heads: [],
            bodies: [],
            legs: [],
            display: [],
            accessory1: [],
            accessory2: [],
            accessory3: [],
            accessory4: [],
        };

        if (!sectionId) {
            return Promise.resolve([]);
        }

        if (API.hasCache && window.sessionStorage.getItem(`categories-${sectionId}`)) {
            return Promise.resolve(window.sessionStorage.getItem(`categories-${sectionId}`));
        }

        return getData().then(() => {
            return Promise.all(
                categoryMap[sectionId].map((collection) => {
                    return fetch(`/collections/${collection}.json`, {
                        method: 'GET',
                        credentials: 'same-origin',
                        redirect: 'follow',
                        agent: null,
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Basic ${btoa(`${API_USERNAME}:${API_PASSWORD}`)}`,
                        },
                        timeout: 5000,
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            for (const key in data) {
                                if (data.hasOwnProperty(key)) {
                                    return {
                                        id: data.collection.id,
                                        title: data.collection.title,
                                        image: data.collection.image.src,
                                        handle: data.collection.handle,
                                    };
                                    // just to show they can be sorted if wanted later...
                                    // .sort((a, b) => a.id - b.id);
                                }
                            }
                        })
                        .catch(function (err) {
                            console.log('Fetch Error :-S', err);
                        });
                })
            );
        });
    }

    /**
     * Get the available products for a category
     *
     * @param {number} productId
     * @return Promise
     */
    getProduct(productId) {
        const fetchMyProducts = (query) => {
            return fetch('/api/2023-04/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/graphql',
                    'Access-Control-Origin': '*',
                    'X-Shopify-Storefront-Access-Token': 'e14901ef020f42eff2b10fbed13e6e18',
                },
                body: query,
            })
                .then((resp) => resp.json())
                .then((result) => {
                    const product = result?.data?.product;
                    return {
                        product: product,
                    };
                })
                .catch(function (err) {
                    console.log('Fetch Error :-S', err);
                    return {
                        product: null,
                        error: err,
                    };
                });
        };

        return fetchMyProducts(getProductById(productId));
    }

    /**
     * Get the available products for a category
     *
     * @param {number} categoryId
     * @param {string} categoryHandle
     * @param {object} filters
     * @param {string} afterCursor
     * @return Promise
     */
    getProducts(categoryId, categoryHandle, filters = { namespace: '', key: '', value: '' }, afterCursor, skintone) {
        if (API.hasCache && window.sessionStorage.getItem(`products-${categoryId}`)) {
            return Promise.resolve(window.sessionStorage.getItem(`products-${categoryId}`));
        }

        let thequery = '';
        const fetchMyProducts = (query) => {
            return fetch('/api/2023-04/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/graphql',
                    'Access-Control-Origin': '*',
                    'X-Shopify-Storefront-Access-Token': 'e14901ef020f42eff2b10fbed13e6e18',
                },
                body: query,
            })
                .then((resp) => resp.json())
                .then((result) => {
                    // console.log('getProducts - API response 2: ', { result });
                    const products = result?.data?.collection?.products?.edges.filter(
                        (product) =>
                            product.node.id !== 'gid://shopify/Product/3235744972864' &&
                            product.node.id !== 'gid://shopify/Product/3235769024576' &&
                            product.node.id !== 'gid://shopify/Product/3235779969088' &&
                            product.node.id !== 'gid://shopify/Product/3235784294464' &&
                            product.node.id !== 'gid://shopify/Product/3235786784832' &&
                            product.node.id !== 'gid://shopify/Product/3235789307968' &&
                            product.node.id !== 'gid://shopify/Product/3235789307968' &&
                            product.node.id !== 'gid://shopify/Product/3235789307968'
                    );

                    return {
                        products,
                        hasNextPage: result?.data?.collection?.products?.pageInfo.hasNextPage,
                    };
                })
                .catch(function (err) {
                    console.log('Fetch Error :-S', err);
                    return {
                        products: [],
                        hasNextPage: false,
                        error: err,
                    };
                });
        };

        if (categoryId === 'heads' && afterCursor !== null && afterCursor !== '') {
            thequery = getPaginatedProductVariants(categoryHandle, skintone, afterCursor);
        } else if (categoryId === 'heads') {
            thequery = getInitialProductVariants(categoryHandle, skintone);
        } else if (filters && filters.value !== '' && afterCursor !== null && afterCursor !== '') {
            thequery = getFilteredProductsFromCollectionPagination(categoryHandle, filters, afterCursor);
        } else if (filters && filters.value !== '') {
            thequery = getFilteredProductsFromCollection(categoryHandle, filters);
        } else if (afterCursor === '' || afterCursor === null) {
            thequery = getInitialProductsFromCollection(categoryHandle);
        } else {
            thequery = getPaginatedProductsFromCollection(categoryHandle, afterCursor);
        }

        return fetchMyProducts(thequery);
    }

    /**
     * Get the details of variations on a product
     *
     * @param {number} productId
     * @return Promise
     */
    getVariations(productId, productHandle) {
        if (API.hasCache && window.sessionStorage.getItem(`variations-${productId}`)) {
            return Promise.resolve(window.sessionStorage.getItem(`variations-${productId}`));
        }

        const params = ['limit=250'];

        return fetch(`/products/${productHandle}.json?${params.join('&')}`, {
            method: 'GET',
            credentials: 'same-origin',
            redirect: 'follow',
            agent: null,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Basic ${btoa(`${API_USERNAME}:${API_PASSWORD}`)}`,
            },
            timeout: 5000,
        })
            .then((resp) => resp.json())
            .catch(function (err) {
                console.log('Fetch Error :-S', err);
            });
    }

    /**
     * Retrieving the attribute data based on attribute ID
     * @param attributeId
     * @param productId
     */
    getProductAttribute(attributeId, productId) {
        // example call from existing app...
        // "gid://shopify/Product/3163778646080"
        // https://option.boldapps.net/v2/minifigs-dev.myshopify.com/generate_option/3163778646080?tmp=1661440080900
        return fetch(
            `https://options.shopapps.site/v2/minifigs-dev.myshopify.com/generate_option/${attributeId}?tmp=${Date.now()}`,
            {
                method: 'GET',
                credentials: 'same-origin',
                redirect: 'follow',
                agent: null,
                timeout: 5000,
            }
        )
            .then((response) => response.json())
            .then(function (response) {
                // console.log(`Fetch products, getProductAttribute: ${attributeId}: `, new Date(Date.now()));
                return response;
            })
            .catch(function (err) {
                console.log('Fetch Error :-S', err);
            });
    }

    /**
     * Get the "terms" for an attribute
     *
     * @param {number} attributeId
     * @param {number} productId
     * @return Promise
     */
    getAttributeTerms(attributeId, productId) {
        if (API.hasCache && window.sessionStorage.getItem(`attributeterms-${attributeId}`)) {
            return Promise.resolve(window.sessionStorage.getItem(`attributeterms-${attributeId}`));
        }

        return Promise.resolve();
    }

    /**
     * Add the provided products to the basket
     *
     * @param {object} products
     * @param {string} projectTitle - The name of the project
     * @return Promise
     */
    async buy(products, projectTitle, skintone) {
        projectTitle = this.getProjectTitle(projectTitle);
        // let ret = Promise.resolve();
        const requests = [];

        function dataURItoBlob(dataURI) {
            var binary = atob(dataURI.split(',')[1]);
            var array = [];

            for (let i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], { type: 'image/png' });
        }

        for (const i in products) {
            const product = products[i];

            if (product === null || product.length === 0) {
                continue;
            }

            // does not contain image data... then do the push
            // otherwise this needs to be handled by BOLD...
            // console.log('production data: ', product.productFormJsonValues);
            // console.log('product.productFormJsonValues.properties: ', product.productFormJsonValues.properties);
            if (
                product.productFormJsonValues.properties['Please upload image you would like us to use.'] ||
                product.productFormJsonValues.properties[
                    'Please upload a screenshot of the head from our website you would like to edit.'
                ] ||
                product.productFormJsonValues.properties['Attach another image if relevant'] ||
                product.productFormJsonValues.properties[
                    'Please upload a screenshot of the other head from our website you would like to edit.'
                ] ||
                product.productFormJsonValues.properties['Attach another image if relevant 1'] ||
                product.productFormJsonValues.properties['Upload an image we can use as a reference'] ||
                product.productFormJsonValues.properties['Upload a second image (if appropriate)'] ||
                product.productFormJsonValues.properties['Upload a third image (if appropriate)'] ||
                product.productFormJsonValues.properties['Upload your image'] ||
                product.productFormJsonValues.properties['If own image chosen, please upload it here'] ||
                product.productFormJsonValues.properties['If own image chosen, please upload it here 1'] ||
                product.productFormJsonValues.properties['Upload University/College logo'] ||
                product.productFormJsonValues.properties[
                    'Upload an image of the team kit (if you would like to give us a reference to work from):'
                ] ||
                product.productFormJsonValues.properties[
                    'Upload an image of the team kit (if you would like to give us a reference to work from)'
                ]
            ) {
                const { productFormJsonValues } = product;
                const formData = new FormData();
                formData.append('quantity', productFormJsonValues.quantity);
                formData.append('id', productFormJsonValues.id);
                for (const key in productFormJsonValues.properties) {
                    if (productFormJsonValues.properties.hasOwnProperty(key)) {
                        if (
                            key === 'Please upload image you would like us to use.' ||
                            key === 'Please upload a screenshot of the head from our website you would like to edit.' ||
                            key === 'Attach another image if relevant' ||
                            key ===
                                'Please upload a screenshot of the other head from our website you would like to edit.' ||
                            key === 'Attach another image if relevant 1' ||
                            key === 'Upload an image we can use as a reference' ||
                            key === 'Upload a second image (if appropriate)' ||
                            key === 'Upload a third image (if appropriate)' ||
                            key === 'Upload your image' ||
                            key === 'If own image chosen, please upload it here' ||
                            key === 'If own image chosen, please upload it here 1' ||
                            key === 'Upload University/College logo' ||
                            key ===
                                'Upload an image of the team kit (if you would like to give us a reference to work from):' ||
                            key ===
                                'Upload an image of the team kit (if you would like to give us a reference to work from)'
                        ) {
                            if (productFormJsonValues.properties[key]) {
                                const blob = dataURItoBlob(productFormJsonValues.properties[key]);
                                const file = new File([blob], 'img.png', {
                                    type: 'image/png',
                                    lastModified: new Date().getTime(),
                                });

                                formData.append(`properties[${key}]`, file, 'img.png');
                            }
                        } else {
                            formData.append(`properties[${key}]`, productFormJsonValues.properties[key]);
                        }
                    }
                }

                try {
                    const res = await fetch('/cart/add.js', {
                        body: formData,
                        method: 'POST',
                    });
                    console.log(res);
                } catch (error) {
                    console.error('error', error);
                }
            } else {
                requests.push(product.productFormJsonValues);
            }
        }

        const postData = { items: requests };
        // Function to fetch + POST the data to the Shopify API
       
        return await fetch('/cart/add.js', {
            body: JSON.stringify(postData),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest',
            },
            method: 'POST',
        }).then((response) => { 
            return response.json(); 
        });
    }

    getProjectTitle(projectTitle) {
        if (projectTitle) {
            return projectTitle;
        }

        const now = new Date();
        let month = '';
        let hour = '';
        let minutes = '';

        switch (now.getMonth()) {
            case 0:
                month = 'January';
                break;
            case 1:
                month = 'February';
                break;
            case 2:
                month = 'March';
                break;
            case 3:
                month = 'April';
                break;
            case 4:
                month = 'May';
                break;
            case 5:
                month = 'June';
                break;
            case 6:
                month = 'July';
                break;
            case 7:
                month = 'August';
                break;
            case 8:
                month = 'September';
                break;
            case 9:
                month = 'October';
                break;
            case 10:
                month = 'November';
                break;
            case 11:
                month = 'December';
                break;
        }

        hour = now.getHours() < 10 ? `0${now.getHours()}` : now.getHours();
        minutes = now.getMinutes() < 10 ? `0${now.getMinutes()}` : now.getMinutes();

        return `Unnamed project ${now.getDate()} ${month} ${now.getFullYear()}, ${hour}:${minutes}`;
    }
}

API.hasCache = typeof window.sessionStorage === 'object';

const api = new API();

export default api;
